import React from 'react';
import { TartaWordmark } from './TartaWordmark';
type Props = {
  size?: number;
  variant?: 'dark' | 'light';
  withTagline?: boolean;
  className?: string;
};
export function TartaEmblem({
  size = 120,
  variant = 'dark',
  withTagline = true,
  className = ''
}: Props) {
  const isDark = variant === 'dark';
  const bg = isDark ? 'bg-chocolate' : 'bg-cream';
  const fg = isDark ? 'text-cream' : 'text-chocolate';
  return <div className={`${bg} ${fg} rounded-full flex flex-col items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} aria-label="TARTA — A slice of heaven" data-id="element-239">
      <TartaWordmark height={size * 0.16} strokeWidth={1.5} data-id="element-240" />
      {withTagline && <span className="mt-[0.6em] tracking-[0.05em] opacity-90 font-sans font-light" style={{
      fontSize: size * 0.058
    }} data-id="element-241">
          A slice of heaven
        </span>}
    </div>;
}